import { createPinia, getActivePinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createResetPlugin } from '@/plugins/pinia/resetPlugin';
import { storageUtils } from '@/utils';

const pinia = createPinia();

// 注册持久化插件（必须在 reset 插件之前）
pinia.use(piniaPluginPersistedstate);

// 注册重置插件
pinia.use(createResetPlugin());

/**
 * 全局重置所有 store
 *
 * 功能：
 * 1. 重置所有 store 的状态到初始值
 * 2. 清除所有 persist 插件保存的数据
 * 3. 清除所有 localStorage 和 sessionStorage
 *
 * 使用场景：
 * - 用户登出
 * - 切换账号
 * - 清除缓存
 */
export function resetAllStores() {
  const activePinia = getActivePinia();

  if (!activePinia) {
    return;
  }

  // 1. 遍历所有 store，重置状态并清理各自的 persist 数据
  //    优点：支持 store 级别的 skipOnReset 配置
  (activePinia as any)._s.forEach((store: any) => {
    if (store.$resetAll) {
      store.$resetAll();
    }
  });

  // 安全清除 storage（保留白名单中的 key）
  storageUtils.clear();
  // sessionStorage.clear();
}

export default pinia;